import React, { useEffect, useState } from 'react';
import './index.css';
import { ArrowRight, LoadingSpinner } from '../Icons';

interface CardDashboardProps {
  cards: React.ReactNode[];
  pageSize?: number;
  loading?: boolean;
}

const CardDashboard: React.FC<CardDashboardProps> = ({ cards, pageSize = 12, loading = true }) => {

  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(cards.length / pageSize);

  const handleNextPage = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  const handlePrevPage = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = Math.min(startIndex + pageSize, cards.length);
  const currentCards = cards.slice(startIndex, endIndex);

  return (
    <>

      <div className={`card-dashboard ${loading ? 'loading' : 'ready'}`}>

        <div className='loader'>
          <LoadingSpinner />
        </div>

        <div className='content'>
          <section className='dashboard-page-navigator'>
            <p>Mostrando {startIndex + 1}-{endIndex} de {cards.length} resultados</p>

            <div className='dashboard-page-navigator-controls'>
              <p> Página {currentPage} de {totalPages} </p>
              <button disabled={currentPage === 1} onClick={handlePrevPage}>
                <ArrowRight className='dashboard-page-navigator-icon rotate-180' />
              </button>

              <button disabled={currentPage === totalPages} onClick={handleNextPage}>
                <ArrowRight className='dashboard-page-navigator-icon' />
              </button>

            </div>
          </section>
          {currentCards}
        </div>
      </div>
    </>);
};

export default CardDashboard;